// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f40dc630545b1a58","5405":"13aa2e25e7c1b2a8"}[chunkId] + ".css";
};